export const launchGameByName = async ({
  provider,
  gameName,
  username,
  tokenUrl,
  launchUrl,
  allGamesFlat,
  location,
}) => {
  try {
    const game = allGamesFlat.find(
      (g) =>
        g.provider?.toLowerCase() === provider.toLowerCase() &&
        g.gameName?.toLowerCase() === gameName.toLowerCase()
    )

    if (!game) {
      alert("Game not found.")
      return
    }

    const requestUrl = `${tokenUrl}?u=${username}&g=${game.gameId}&t=transfer&m=mobile`

    const response = await fetch(requestUrl)

    if (!response.ok) {
      alert("Failed to fetch game token.")
      return
    }

    const data = await response.json()

    if (!data?.token) {
      alert("Token not received.")
      return
    }

    const stored = JSON.parse(localStorage.getItem("recentGames")) || []
    const filtered = stored.filter((id) => id !== game.gameId)
    filtered.unshift(game.gameId)
    localStorage.setItem("recentGames", JSON.stringify(filtered.slice(0, 6)))

    const mobileIndicator = window.innerWidth <= 768 ? "1" : ""
    const currentPageUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`

    const gameUrl = `${launchUrl}?s=${data.token}&l=en&m=${mobileIndicator}&h=${encodeURIComponent(
      currentPageUrl
    )}`

    if (window.innerWidth <= 768) {
      window.location.href = gameUrl
    } else {
      window.open(
        gameUrl,
        "gameWindow",
        "width=1024,height=768,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes"
      )
    }
  } catch (err) {
    console.error(err)
    alert("An unexpected error occurred.")
  }
}
